import React from "react";

export default function SettlementPdfSummaryTable({ rows }) {
  return (
    <div className="settlement-pdf-summary-table">
      {rows.map((row) => (
        <div className={`settlement-pdf-summary-row ${row.modifier || ""}`} key={row.title}>
          <div className="settlement-pdf-summary-title">{row.title}</div>
          <div className="settlement-pdf-summary-value">
            {String(row.value || "").startsWith("$") ? (
              <>
                <span className="settlement-pdf-summary-currency">$</span>
                <span className="settlement-pdf-summary-amount">{String(row.value).slice(1)}</span>
              </>
            ) : (
              <span className="settlement-pdf-summary-amount">{row.value}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
